import { render, staticRenderFns } from "./SensitiveChanges.vue?vue&type=template&id=7d7da6de&scoped=true&"
import script from "./SensitiveChanges.vue?vue&type=script&lang=js&"
export * from "./SensitiveChanges.vue?vue&type=script&lang=js&"
import style0 from "./SensitiveChanges.vue?vue&type=style&index=0&id=7d7da6de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7da6de",
  null
  
)

export default component.exports